module.exports = __webpack_public_path__ + "static/media/chubb-claims-block-residential.5b299cc3.png";